<template>
  <div class="detail-dialog">
    <el-dialog :visible.sync="dialogVisible" width="20%" :title="`每月有效期`"  @close="onClose">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        @cell-click="onCellClick"
        @keyup.enter.native="onEnterPress"
      >
        <el-table-column prop="month" :label="`月份`"> </el-table-column>
        <el-table-column prop="deadline" :label="name"> </el-table-column>
        <el-table-column prop="" :label="`保存`">
          <el-button class="mr10 mb10" type="primary" size="mini" @click="confirm">保存</el-button>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import DynamicInput from "./DynamicInput.vue";
import {updateValidationUrl} from '@/api.js'

export default {
  name: "DetailDialog",
  components: { DynamicInput },
  props:{
    updateList:{
      type:Function,
      default(){
        return ()=>{}
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      activeInput: null, //当前激活的输入框
      activeCellInfo: null, //当前击中的单元格信息
      isEntered: true,
      tableData: [],
      name:''
    };
  },
  computed: {},
  created() {

  },
  methods: {
    // 单元格单击
    onCellClick(row, column, cell, event) {
      if (column.label === `月份` || column.label === `保存`) return; //排除不需要编辑的单元格
      if( !this.isEntered){   //没有保存编辑也不允许创建新的
        return this.$message.error(`请保存后再操作`)
      }
      this.isEntered = false;
      const div = document.createElement("div"); //创建元素用于动态创建的输入框组件的挂载。vue2并不支持文档碎片挂载
      const vm = Vue.extend(DynamicInput); //动态创建输入框组件并挂载
      this.activeInput = new vm({
        propsData: { cell:row },
      }).$mount(div);
      cell.appendChild(this.activeInput.$el); //将动态创建的组件插入到单元格中
      cell.querySelector("input").focus(); //将动态创建的输入框聚焦
      this.activeCellInfo = { row, column, cell }; //将当前cell保存，以便后期清除
    },
    async onEnterPress(e) {
      //监听enter事件，发送请求
      try {
        let {deadline,pack_option,handle_option,month}= this.activeCellInfo.row

        let res =await this.$request('post',updateValidationUrl,{
            "deadline":deadline,//有效期
            pack_option,//包装方式值
            handle_option,//处理方式值
            month:[month]
        })
        if (res) {
          this.$message.success(`更新成功`);
          //请求成功销毁输入框
          this.activeInput &&
            this.activeCellInfo.cell.removeChild(this.activeInput.$el);
          this.isEntered = true;
          this.activeInput = null;
          this.activeCellInfo = null;
        }
      } catch (err) {
        return
      }
    },
    open(row, column){
      this.dialogVisible = true;
      this.tableData = row[column.property].month_detail
      if(row[column.property].handle_option === 41 || row[column.property].handle_option === 40){
        this.name = `有效期小时`
      }else{
        this.name = `有效期天数`
      }
    },
    onClose(){
      //关闭弹框清除创建的动态输入框
          this.activeInput &&
            this.activeCellInfo.cell.removeChild(this.activeInput.$el);
          this.isEntered = true;
          this.activeInput = null;
      //重新请求列表数据，防止未保存数据打开弹窗数据也更新
      this.updateList()

    },
    confirm() {
      if (this.activeCellInfo) {
        this.onEnterPress()
      } else {
        this.$message.error(`请选择要修改的有效期`)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.detail-dialog /deep/.el-table {
  width: 100% !important;
}

.detail-dialog /deep/ .el-dialog .el-dialog__body {
  padding: 0 !important;
}

.monthButton {
  text-align: right;
}
</style>